<template>
  <div class="introView">
    <div id="fb-root"></div>
    <!-- <script
      type="application/javascript"
      async
      defer
      crossorigin="anonymous"
      src="https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v11.0&appId=808190590110686&autoLogAppEvents=1"
      nonce="tgfpLbCx"
    ></script> -->
    <template v-if="packages.isenable">
      <i class="close fas fa-times" @click="closeModal"></i>
      <img :src="APIURL + 'images/items/' + packages.package.packageImg" alt="" />
      <div class="share">
        <ShareNetwork
          network="facebook"
          :url="'https://dali-mart.com/share.php?id=' + shareId"
          :title="packages.package.packageName + ' - 大立生鮮超市'"
          :description="ToText('packages.package.packageContent')"
        >
          <i class="fab fa-facebook-f"></i>
          <span>FB分享</span>
        </ShareNetwork>

        <ShareNetwork
          network="line"
          :url="'https://dali-mart.com/share.php?id=' + shareId"
          :title="packages.package.packageName + ' - 大立生鮮超市'"
          :description="ToText('packages.package.packageContent')"
        >
          <i class="fab fa-line"></i>
          <span>LINE分享</span>
        </ShareNetwork>
        <!-- <div
          class="fb-share-button"
          :data-href="'https://dali-mart.com/share.php?id=4550002794255' + shareId"
          data-layout="button"
          data-size="large"
        >
          <a
            target="_blank"
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
            class="fb-xfbml-parse-ignore"
            >分享</a
          >
        </div> -->
      </div>
      <div class="hd">
        <h2 class="title">{{ packages.package.packageName }}</h2>
        <h3 class="price">
          NT {{ packages.package.packagePrice }} 元 / {{ packages.package.unit }}
        </h3>
      </div>

      <div class="packageInner">
        <h4>組合內容</h4>
        <div class="product" v-for="item in packages.product[0]" :key="item.productId">
          <img :src="APIURL + 'images/items/' + item.productImg" alt="" />
          <h3 style="text-align:right;">
            {{ item.names }} {{ item.amount }} {{ item.unit }} / {{ packages.package.unit }}<br />
            <span v-if="item.remain == '0'">(補貨中)<br /></span>
            <span v-if="item.productEnable == '0'" style="color:red">( 已下架 )</span>
          </h3>
          <!-- <h5>x</h5> -->
        </div>
      </div>
      <div class="info">
        <h4>商品資訊</h4>
        <p v-html="packages.package.packageContent"></p>
      </div>
      <div class="select" v-if="packages.package.packageAmount > 0 && packages.package.exist == 1">
        <h4>選擇數量({{ packages.package.unit }})</h4>
        <div class="count">
          <button @click="lessCart(packages.package.packageId)">
            <i class="fas fa-minus"></i>
          </button>
          <input
            style="border-radius: 50px"
            type="text"
            readonly
            @click="openCountModal('package', packages.package)"
            :value="getCartItemCount(packages.package.packageId, 1)"
          />
          <!-- <h6>{{ getCartItemCount(packages.package.packageId, 1) }}</h6> -->
          <button
            @click="
              addCart(
                packages.package.packageId,
                packages.package.packageName,
                packages.package.packagePrice,
                packages.package.packageImg,
                packages.package.unit,
                1,
                packages.product[0],
                packages.package.packageAmount
              )
            "
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>
        <!-- <h5>還剩 {{ packages.package.packageAmount }} {{ packages.package.unit }}</h5> -->
      </div>
    </template>
    <template v-if="product.isenable">
      <i class="close fas fa-times" @click="closeModal"></i>
      <img :src="APIURL + 'images/items/' + product.productImg" alt="" />
      <div class="share">
        <ShareNetwork
          network="facebook"
          :url="'https://dali-mart.com/share.php?id=' + shareId"
          :title="product.names + ' - 大立生鮮超市'"
          :description="ToText('product.content')"
        >
           <i class="fab fa-facebook-f"></i>
          <span>FB分享</span>
        </ShareNetwork>

        <ShareNetwork
          network="line"
          :url="'https://dali-mart.com/share.php?id=' + shareId"
          :title="product.names + ' - 大立生鮮超市'"
          :description="ToText('product.content')"
        >
          <i class="fab fa-line"></i>
          <span>LINE分享</span>
        </ShareNetwork>
        <!-- <ShareNetwork
          network="facebook"
          :url="'https://dali-mart.com/share.php?id=' + shareId"
          title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
          description="This week,
           I’d like to introduce you to 'Vite', which means 'Fast'.
           It’s a brand new development setup created by Evan You."
        >
          Share on Facebook
        </ShareNetwork> -->
        <!-- <div
          class="fb-share-button"
          :data-href="'https://dali-mart.com/share.php?id=' + shareId"
          data-layout="button"
          data-size="large"
        >
          <a
            target="_blank"
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
            class="fb-xfbml-parse-ignore"
            >分享</a
          >
        </div>-->
        <!-- <div
          class="line-it-button"
          data-lang="zh_Hant"
          data-type="share-a"
          data-ver="3"
          :data-url="'https://dali-mart.com/share.php?id='+ shareId"
          data-color="default"
          data-size="large"
          data-count="false"
          style="display: none;"
        ></div>
        <script
          type="application/javascript"
          src="https://www.line-website.com/social-plugins/js/thirdparty/loader.min.js"
          async="async"
          defer="defer"
        ></script> -->
      </div>
      <div class="hd">
        <h2 class="title">{{ product.names }}</h2>
        <h3 class="price">NT {{ product.sellPrice }} 元/{{ product.unit }}</h3>
      </div>

      <div class="info">
        <h4>商品資訊</h4>
        <p v-html="product.content"></p>
      </div>
      <div class="select" v-if="product.amount > 0">
        <h4>選擇數量(箱)</h4>
        <div class="count">
          <button @click="lessCart(product.productId)">
            <i class="fas fa-minus"></i>
          </button>
          <input
            style="border-radius: 50px"
            type="text"
            readonly
            @click="openCountModal('product', product)"
            :value="getCartItemCount(product.productId, 0)"
          />
          <!-- <h6>{{ getCartItemCount(product.productId, 0) }}</h6> -->
          <button
            @click="
              addCart(
                product.productId,
                product.names,
                product.sellPrice,
                product.productImg,
                product.unit,
                product.type,
                product.detail,
                product.amount
              )
            "
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>

        <h5>還剩 {{ product.amount }} {{ product.unit }}</h5>
      </div>
    </template>
    <Cart />

    <div class="productModal" v-if="CountModalShow">
      <div class="bg" @click="CountModalShow = false"></div>
      <div class="modal">
        <div class="modalcontent">
          <img :src="APIURL + 'images/items/' + ModalItem.image" alt="" />

          <div class="content">
            <h3>{{ ModalItem.name }}</h3>
            <h4>NT {{ ModalItem.price }} / {{ ModalItem.unit }}</h4>
            <!-- <h5 v-if="ModalItem.amount > 0">還剩 {{ ModalItem.amount }} {{ ModalItem.unit }}</h5>
            <h5 v-if="ModalItem.amount <= 0">補貨中</h5> -->
            <label v-if="ModalItem.amount > 0" for="">數量：</label>
            <input v-if="ModalItem.amount > 0" type="text" v-model="ModalItem.value" />
          </div>
        </div>
        <div class="modalfooter">
          <button @click="CountModalShow = false">取消</button>
          <button @click="ModalAddProduct">確認</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Cart from '@/components/cart.vue';

export default {
  components: {
    Cart,
  },
  data() {
    return {
      shareId: '',
      APIURL: process.env.VUE_APP_APIURL,
      URL: process.env.VUE_APP_URL,
      packages: {},
      product: {},
      ModalItem: {
        type: '',
        image: '',
        name: '',
        price: '',
        id: '',
        value: '',
        unit: '',
        amount: '',
        detail: [],
      },
      CountModalShow: false,
    };
  },
  metaInfo() {
    return {
      title: this.packages.isenable === 1 ? this.packages.package.packageName : this.product.names,
      meta: [
        {
          name: 'description',
          content:
            this.packages.isenable === 1
              ? `路竹大立生鮮超市-${this.packages.package.packageName}`
              : `路竹大立生鮮超市-${this.product.names}`,
        },
      ],
    };
  },
  created() {
    // console.log(this.$route);
    // console.log(`${process.env.VUE_APP_URL}index/${this.$route.params.id}`);
    const vm = this;
    console.log(vm.$route.params);
    if (vm.$route.params.id) {
      vm.$store.commit('setLoading', true);
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/page/get_item_comment`,
        type: 'POST',
        data: {
          productId: vm.$route.params.id,
        },
        success(res) {
          vm.$store.commit('setLoading', false);
          console.log(res);
          const data = JSON.parse(res);
          console.log(data);
          if (data === 2) {
            vm.$router.push('/');
          } else if (data.package) {
            vm.packages = data.package;
            vm.packages.isenable = 1;
          } else if (data.product) {
            const product = data.product[0];
            vm.product = product;
            vm.product.isenable = 1;
          }
          vm.shareId = vm.$route.params.id;
        },
      });
    } else {
      vm.$router.push('/');
    }
  },
  computed: {
    CartData() {
      return this.$store.state.CartData;
    },
  },
  methods: {
    ToText(HTML) {
      const input = HTML;
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ');
    },
    closeModal() {
      this.$router.push('/');
    },
    getCartItemCount(id, type) {
      const vm = this;
      vm.hasItem = false;
      vm.count = 0;
      if (type === 1) {
        // console.log('packg');
        // console.log(`package${id}`);
        vm.CartData.forEach((item) => {
          // console.log(item.product_id, `package${id}`);
          if (item.product_id === `${id}`) {
            vm.hasItem = true;
            vm.count = item.count;
            // console.log(item, item.count);
          }
        });
      } else {
        vm.CartData.forEach((item) => {
          if (item.product_id === id) {
            vm.hasItem = true;
            vm.count = item.count;
          }
        });
      }

      return vm.count;
    },
    addCart(id, names, sellPrice, image, unit, type, detail, amount) {
      // console.log(id, names, sellPrice, image, unit, type, detail);
      if (amount > this.getCartItemCount(id, type)) {
        if (type === 1) {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: `${id}`,
            product_names: names,
            product_sellPrice: sellPrice,
            product_image: image,
            product_unit: unit,
            count: 1,
            isPackage: 1,
            products: detail,
          });
        } else {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: id,
            product_names: names,
            product_sellPrice: sellPrice,
            product_image: image,
            product_unit: unit,
            count: 1,
            isPackage: 0,
          });
        }
      }
    },
    lessCart(id) {
      this.$store.dispatch('LESS_TO_CART', {
        product_id: `${id}`,
      });
    },
    openCountModal(type, items) {
      const vm = this;
      if (type === 'package') {
        console.log('items', items);
        vm.ModalItem.type = type;
        vm.ModalItem.image = items.packageImg;
        vm.ModalItem.name = items.packageName;
        vm.ModalItem.price = items.packagePrice;
        vm.ModalItem.id = items.packageId;
        vm.ModalItem.amount = items.packageAmount;
        vm.ModalItem.unit = items.unit;
        vm.ModalItem.value = vm.getCartItemCount(items.packageId, 'package');
        const detail = vm.packages.product[0];
        vm.ModalItem.detail = detail;
        vm.CountModalShow = true;
      } else if (type === 'product') {
        vm.ModalItem.type = type;
        vm.ModalItem.image = items.productImg;
        vm.ModalItem.name = items.names;
        vm.ModalItem.price = items.sellPrice;
        vm.ModalItem.id = items.productId;
        vm.ModalItem.unit = items.unit;
        vm.ModalItem.amount = items.amount;

        vm.ModalItem.value = vm.getCartItemCount(items.productId, 'product');
        vm.CountModalShow = true;
      }
    },
    ModalAddProduct() {
      const vm = this;
      if (Number.isNaN(parseInt(vm.ModalItem.value, 10))) {
        alert('請輸入數字');
      } else if (parseInt(vm.ModalItem.value, 10) > vm.ModalItem.amount) {
        alert('超過庫存');
      } else if (vm.ModalItem.type === 'package') {
        if (
          parseInt(vm.ModalItem.value, 10) === 0
          && vm.getCartItemCount(vm.ModalItem.id, 'package') === 0
        ) {
          vm.CountModalShow = false;
        } else {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: vm.ModalItem.id,
            product_names: vm.ModalItem.name,
            product_sellPrice: vm.ModalItem.price,
            product_image: vm.ModalItem.image,
            product_unit: vm.ModalItem.unit,
            count:
              parseInt(vm.ModalItem.value, 10) - vm.getCartItemCount(vm.ModalItem.id, 'package'),
            isPackage: 1,
            products: vm.ModalItem.detail,
          });
          vm.CountModalShow = false;
        }
      } else if (vm.ModalItem.type === 'product') {
        if (
          parseInt(vm.ModalItem.value, 10) === 0
          && vm.getCartItemCount(vm.ModalItem.id, 'product') === 0
        ) {
          vm.CountModalShow = false;
        } else {
          this.$store.dispatch('ADD_TO_CART', {
            product_id: vm.ModalItem.id,
            product_names: vm.ModalItem.name,
            product_sellPrice: vm.ModalItem.price,
            product_image: vm.ModalItem.image,
            product_unit: vm.ModalItem.unit,
            count:
              parseInt(vm.ModalItem.value, 10) - vm.getCartItemCount(vm.ModalItem.id, 'product'),
            isPackage: 0,
          });
          vm.CountModalShow = false;
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
